export default __webpack_public_path__ + "static/media/pexels-karolina-grabowska-5632331-min.3b7a9281.jpg";